import { createClient } from '@supabase/supabase-js';
import mockSupabase from './mock/mockSupabase';

/**
 * Mock mode is opt-in and doubly guarded:
 *   1. import.meta.env.DEV  — false in any `vite build`, so a production
 *      bundle can never take this branch even if the flag leaked in.
 *   2. VITE_USE_MOCK        — set only in the local, gitignored .env.
 *
 * When the flag is absent (Vercel, CI, anyone else's checkout) the real client
 * is created exactly as before, including the missing-env guard below.
 */
const USE_MOCK = import.meta.env?.DEV && import.meta.env?.VITE_USE_MOCK === 'true';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

if (!USE_MOCK && (!supabaseUrl || !supabaseAnonKey)) {
  throw new Error('Missing Supabase environment variables. Please check your .env file for VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY');
}

// Custom storage with error handling
const customStorage = {
  getItem: (key) => {
    try {
      return window.localStorage?.getItem(key);
    } catch (error) {
      console.error('Storage getItem error:', error);
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      window.localStorage?.setItem(key, value);
    } catch (error) {
      console.error('Storage setItem error:', error);
    }
  },
  removeItem: (key) => {
    try {
      window.localStorage?.removeItem(key);
    } catch (error) {
      console.error('Storage removeItem error:', error);
    }
  }
};

export const supabase = USE_MOCK
  ? mockSupabase
  : createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
        storage: customStorage,
        storageKey: 'supabase.auth.token'
      }
    });

export const isMockMode = USE_MOCK;
